const PaymentOptionsEnum = {
  FULL: 'full',
  MANUAL: 'manual',
  PARTIAL: 'partial',
};

export default PaymentOptionsEnum;
